<template>
  <v-container id="home">
    <v-row>
      <!-- Current campaign carousel -->
      <v-col cols="12" lg="6" v-if="this.$store.getters['config/hasCampaigns']">
        <MaterialCard
          elevation="0"
          color="primary"
          :title="this.$t('title.active_promotions')"
          class="tour-start"
          offset="10"
        >
          <v-carousel
            height="400"
            hide-delimiters
            :show-arrows="this.$store.state.config.campaigns.length > 1"
            interval="8000"
            cycle
            :dark="$vuetify.theme.dark"
            :light="!$vuetify.theme.dark"
          >
            <v-carousel-item
              v-for="(campaign, index) in this.$store.state.config.campaigns"
              :key="index"
            >
              <v-row class="fill-height" align="end">
                <v-col cols="12">
                  <div class="text-center display-3">
                    {{ campaign.name }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div
                    class="text-center display-1"
                    style="max-height: 80px; overflow: hidden"
                  >
                    {{ campaign.description }}
                  </div>
                </v-col>
                <v-col>
                  <v-row align="center" justify="center">
                    <v-col cols="auto">
                      <div class="text-center display-3 font-weight-medium">
                        {{
                          $t("message.collected_stamps", {
                            collected_stamps: getCollectedStamps(campaign)
                          })
                        }}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    large
                    @click="$router.push('campaigns')"
                    color="primary"
                    class="white--text display-2"
                    style="text-transform: none"
                  >
                    {{ $t("button.go_to_promotion") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </MaterialCard>
      </v-col>
      <!-- Topup card -->
      <v-col cols="12" lg="6">
        <MaterialCard
          v-show="this.$store.getters['config/showPrepaidAmount']"
          elevation="0"
          color="primary"
          :title="this.$t('title.prepaid')"
          class="tour-saldo"
          offset="10"
        >
          <v-carousel
            :show-arrows="false"
            hide-delimiters
            height="400"
            :dark="$vuetify.theme.dark"
            :light="!$vuetify.theme.dark"
          >
            <v-carousel-item>
              <v-row class="fill-height" align="end">
                <v-col cols="12">
                  <div class="text-center display-3 pt-5">
                    {{ this.$t("title.your_balance") }}
                  </div>
                </v-col>
                <v-col>
                  <v-row class="mb-0" justify="center">
                    <v-col lg="8" cols="12"
                      ><div class="text-center font-weight-regular display-1">
                        {{ $t("message.topup_card") }}
                      </div></v-col
                    >
                  </v-row>
                  <v-row class="mt-4 mb-4">
                    <v-col class="text-center"
                      ><div class="text-center display-3 font-weight-medium">
                        {{ $store.state.user.balance / 100 || 0 | currency }}
                      </div></v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    @click="balanceTopUpDialogModel = true"
                    large
                    color="primary"
                    class="white--text display-2"
                    style="text-transform: none"
                  >
                    {{ $t("button.topup") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </MaterialCard>
      </v-col>
      <v-col
        cols="12"
        :lg="this.$store.getters['config/hasCampaigns'] ? 12 : 6"
      >
        <MaterialCard
          elevation="0"
          color="grey"
          :title="this.$t('title.qr_code')"
          class="tour-qr"
          offset="10"
        >
          <v-row class="pa-5">
            <v-col cols="12" lg="6" align="center">
              <canvas id="card_barcode"></canvas>
              <div class="text-center display-3">
                {{ this.$store.state.user.card_barcode }}
              </div>
            </v-col>
            <v-col cols="12" lg="5" offset-lg="1" align="center">
              <DownloadWallet></DownloadWallet>
              <DownloadWallet :apple="true"></DownloadWallet>
            </v-col>
          </v-row>
        </MaterialCard>
      </v-col>
    </v-row>
    <!-- Card barcode and wallet card -->

    <!-- Overview for activating promotions -->
    <v-row
      justify="center"
      v-if="
        this.$store.getters['config/hasCampaigns'] &&
          this.hasAvailablePromotions
      "
    >
      <v-col cols="12">
        <MaterialCard
          elevation="0"
          color="primary"
          :title="this.$t('title.redeemable_promotions')"
        >
          <blockquote
            v-if="!this.hasAvailablePromotions"
            class="blockquote text-center"
          >
            {{ $t("message.no_redeemable_promotions_found") }}
          </blockquote>
          <v-row v-if="this.hasAvailablePromotions">
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="6"
              lg="4"
              xl="4"
              v-for="promotion in availableUserPromotions"
              :key="promotion.name"
            >
              <Promotion
                :obtainedStamps="promotion.stamps_collected"
                :img="promotion.image"
                :promotionInit="promotion"
              ></Promotion>
            </v-col>
          </v-row>
        </MaterialCard>
      </v-col>
    </v-row>

    <BalanceTopUpDialog v-model="balanceTopUpDialogModel"></BalanceTopUpDialog
    ><v-tour name="myTour" :options="myOptions" :steps="tourSteps"> </v-tour>
  </v-container>
</template>

<script>
import BalanceTopUpDialog from "./components/BalanceTopUpDialog";
import MaterialCard from "@/components/views/MaterialCard";
import Promotion from "./components/Promotion";
import DownloadWallet from "./components/DownloadWallet";
export default {
  name: "Home",
  components: {
    DownloadWallet,
    Promotion,
    MaterialCard,
    BalanceTopUpDialog
  },
  mounted() {
    if (this.$store.state.user.card_barcode) {
      let QRCode = require("qrcode");
      let canvas = document.getElementById("card_barcode");
      QRCode.toCanvas(
        canvas,
        this.$store.state.user.card_barcode,
        { width: 250 },
        function() {}
      );
    }

    this.$store.state.config.campaigns.forEach(campaign => {
      if (campaign.user_campaigns.length === 0) {
        return;
      }

      campaign.promotions.forEach(promotion => {
        promotion.stamps_collected = campaign.user_campaigns[0]
          ? campaign.user_campaigns[0].stamps_collected
          : 0;
        if (
          promotion.user_promotions.length > 0 &&
          promotion.stamps_collected >= promotion.stamps_required
        ) {
          this.hasAvailablePromotions = true;
          this.availableUserPromotions.push(promotion);
        }
      });
    });
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      show: true,
      hasAvailablePromotions: false,
      balanceTopUpDialogModel: false,
      availableUserPromotions: [],

      tourSteps: [
        {
          target: ".tour-start", // We're using document.querySelector() under the hood
          content: `<div class="pa-5 ">Hier komen alle actieve acties te staan.<br> Je kan meteen zien hoeveel zegels je per actie al hebt gespaard!</div>`
        },
        {
          target: ".tour-promotions", // We're using document.querySelector() under the hood
          content: `<div class="pa-5 ">Hier kan gespaarde zegels inruilen tegen kortingen.</div>`
        },

        {
          target: ".tour-saldo",
          content: `<div class="pa-5 headline">Hier wordt u prepaid saldo getoond.</div>`
        },
        {
          target: ".tour-qr",
          content: `<div class="pa-5 headline">Hier vindt u, uw persoonlijke QR-code<br>Voeg deze QR code toe aan uw mobiele wallet zodat je deze altijd bij je hebt!</div>`
        },
        {
          target: ".tour-nav",
          content: `<div class="pa-5 headline">Bovenaan vindt u de navigatie van de website.<br></div>`
        },
        {
          target: ".tour-trans",
          content: `<div class="pa-5 headline">Transacties opent een dialoog met alle aankopen die u hebt gedaan.</div>`
        },
        {
          target: ".tour-settings",
          content: `<div class="pa-5 headline">Account instellingen opent een dialoog met uw gebruikersinstellingen.<br></div>`
        },
        {
          target: ".tour-settings",
          content: `<div class="pa-5 headline">Einde site tour.<br>Mocht u deze nogmaals willen doen, kunt u deze vinden bij Account instellingen.<br></div>`
        }
      ],
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Stop tour",
          buttonPrevious: "Vorige stap",
          buttonNext: "Volgende stap",
          buttonStop: "Beëindig tour"
        }
      },
      getCollectedStamps(campaign) {
        return campaign.user_campaigns[0]
          ? campaign.user_campaigns[0].stamps_collected
          : 0;
      }
    };
  },
  methods: {
    startTour() {
      this.show = false;
      this.$store.commit("setTourDialog", false);
      this.$tours["myTour"].start();
    }
  }
};
</script>

<style>
.theme--light.v-image {
  color: unset;
}
</style>
